import { render, staticRenderFns } from "./SearchResultNoData.vue?vue&type=template&id=3185024e&scoped=true&"
var script = {}
import style0 from "./SearchResultNoData.vue?vue&type=style&index=0&id=3185024e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3185024e",
  null
  
)

export default component.exports